/* ============================================================
   ALYOR — Theme JavaScript
   ============================================================ */

'use strict';

// ─── HEADER SCROLL ─────────────────────────────────────────────
(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;

  function onScroll() {
    if (window.scrollY > 60) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// ─── MOBILE MENU ────────────────────────────────────────────────
(function () {
  const btn = document.querySelector('.mobile-menu-btn');
  const overlay = document.querySelector('.mobile-drawer-overlay');
  const closeBtn = document.querySelector('.mobile-drawer-close');

  if (!btn || !overlay) return;

  btn.addEventListener('click', () => overlay.classList.add('open'));
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) overlay.classList.remove('open');
  });
  if (closeBtn) closeBtn.addEventListener('click', () => overlay.classList.remove('open'));
})();

// ─── SEARCH OVERLAY ─────────────────────────────────────────────
(function () {
  const openBtns = document.querySelectorAll('[data-search-open]');
  const overlay = document.querySelector('.search-overlay');
  const input = overlay ? overlay.querySelector('.search-input') : null;
  const closeBtn = overlay ? overlay.querySelector('[data-search-close]') : null;

  if (!overlay) return;

  function openSearch() {
    overlay.classList.add('open');
    if (input) input.focus();
  }
  function closeSearch() {
    overlay.classList.remove('open');
  }

  openBtns.forEach(btn => btn.addEventListener('click', openSearch));
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeSearch();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });
})();

// ─── CART DRAWER ────────────────────────────────────────────────
(function () {
  const openBtns = document.querySelectorAll('[data-cart-open]');
  const overlay = document.querySelector('.cart-overlay');
  const closeBtn = overlay ? overlay.querySelector('[data-cart-close]') : null;

  if (!overlay) return;

  function openCart() { overlay.classList.add('open'); }
  function closeCart() { overlay.classList.remove('open'); }

  openBtns.forEach(btn => btn.addEventListener('click', openCart));
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeCart();
  });
})();

// ─── HERO SLIDER ────────────────────────────────────────────────
(function () {
  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.hero-dot');
  if (!slides.length) return;

  let current = 0;
  let timer;

  function goTo(index) {
    slides[current].classList.remove('active');
    dots[current]?.classList.remove('active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current]?.classList.add('active');
  }

  function startTimer() {
    timer = setInterval(() => goTo(current + 1), 5000);
  }

  function stopTimer() { clearInterval(timer); }

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => { stopTimer(); goTo(i); startTimer(); });
  });

  // Touch swipe
  let touchStartX = 0;
  const heroSection = document.querySelector('.hero-section');
  if (heroSection) {
    heroSection.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
    heroSection.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) { stopTimer(); goTo(current + (diff > 0 ? 1 : -1)); startTimer(); }
    });
  }

  goTo(0);
  startTimer();
})();

// ─── ACCORDION ──────────────────────────────────────────────────
(function () {
  const items = document.querySelectorAll('.accordion-item');
  items.forEach(item => {
    const trigger = item.querySelector('.accordion-trigger');
    if (!trigger) return;
    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      // Close all
      items.forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // Open first by default
  if (items.length) items[0].classList.add('open');
})();

// ─── PRODUCT IMAGE GALLERY ───────────────────────────────────────
(function () {
  const thumbnails = document.querySelectorAll('.product-thumbnail');
  const mainImg = document.querySelector('.product-main-image');
  if (!thumbnails.length || !mainImg) return;

  thumbnails.forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      thumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const src = thumb.getAttribute('data-full') || thumb.src;
      mainImg.src = src;
    });
  });
  thumbnails[0]?.classList.add('active');
})();

// ─── COLOR SWATCHES (Product page) ──────────────────────────────
(function () {
  const swatches = document.querySelectorAll('.color-swatch-lg');
  const variantInput = document.querySelector('input[name="id"]');
  const selectedLabel = document.querySelector('.selected-color-name');

  swatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      swatches.forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');

      if (selectedLabel) {
        selectedLabel.textContent = '— ' + (swatch.getAttribute('data-color-name') || '');
      }

      // Update variant id if present
      const variantId = swatch.getAttribute('data-variant-id');
      if (variantInput && variantId) variantInput.value = variantId;

      // Update gallery image if provided
      const imgSrc = swatch.getAttribute('data-image');
      const mainImg = document.querySelector('.product-main-image');
      if (mainImg && imgSrc) mainImg.src = imgSrc;
    });
  });
  swatches[0]?.classList.add('active');
})();

// ─── QUANTITY CONTROL ────────────────────────────────────────────
(function () {
  const minusBtns = document.querySelectorAll('.qty-minus');
  const plusBtns = document.querySelectorAll('.qty-plus');

  minusBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const display = btn.nextElementSibling;
      if (!display) return;
      const val = parseInt(display.value || display.textContent);
      if (val > 1) {
        display.value = val - 1;
        display.textContent = val - 1;
      }
    });
  });

  plusBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const display = btn.previousElementSibling;
      if (!display) return;
      const val = parseInt(display.value || display.textContent);
      display.value = val + 1;
      display.textContent = val + 1;
    });
  });
})();

// ─── ADD TO CART ANIMATION ───────────────────────────────────────
(function () {
  const form = document.querySelector('.product-form');
  const addBtn = document.querySelector('.btn-add-cart');

  if (!form || !addBtn) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const formData = new FormData(form);

    addBtn.textContent = '✓ Added to Cart';
    addBtn.classList.add('added');
    addBtn.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();

      // Update cart count bubble
      const cartCount = await fetch('/cart.js').then(r => r.json());
      const countEl = document.querySelector('.cart-count');
      if (countEl) {
        countEl.textContent = cartCount.item_count;
        countEl.style.display = cartCount.item_count > 0 ? 'flex' : 'none';
      }
    } catch (err) {
      console.error('Add to cart error:', err);
    }

    setTimeout(() => {
      addBtn.textContent = 'Add to Cart';
      addBtn.classList.remove('added');
      addBtn.disabled = false;
    }, 2000);
  });
})();

// ─── WISHLIST TOGGLE ─────────────────────────────────────────────
(function () {
  const wishBtns = document.querySelectorAll('.product-wishlist-btn, .btn-wishlist');
  wishBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      btn.classList.toggle('active');
      const svg = btn.querySelector('svg path');
      if (svg) {
        const isActive = btn.classList.contains('active');
        svg.setAttribute('fill', isActive ? 'currentColor' : 'none');
      }
      const textSpan = btn.querySelector('.wishlist-text');
      if (textSpan) {
        textSpan.textContent = btn.classList.contains('active') ? 'Saved to Wishlist' : 'Add to Wishlist';
      }
    });
  });
})();

// ─── COLLECTION FILTER ───────────────────────────────────────────
(function () {
  const pills = document.querySelectorAll('.filter-pill');
  const sortSelect = document.querySelector('.sort-select');

  pills.forEach(pill => {
    pill.addEventListener('click', () => {
      pills.forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
      const tag = pill.getAttribute('data-filter');
      filterProducts(tag);
    });
  });

  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      sortProducts(sortSelect.value);
    });
  }

  function filterProducts(tag) {
    const cards = document.querySelectorAll('.collection-product-item');
    cards.forEach(card => {
      if (tag === 'All' || !tag) {
        card.style.display = '';
      } else {
        const cardTags = (card.getAttribute('data-tags') || '').toLowerCase();
        const cardType = (card.getAttribute('data-type') || '').toLowerCase();
        const match = cardTags.includes(tag.toLowerCase()) || cardType.includes(tag.toLowerCase());
        card.style.display = match ? '' : 'none';
      }
    });
  }

  function sortProducts(val) {
    const grid = document.querySelector('.collection-products-grid');
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('.collection-product-item'));

    cards.sort((a, b) => {
      const priceA = parseFloat(a.getAttribute('data-price') || '0');
      const priceB = parseFloat(b.getAttribute('data-price') || '0');
      if (val === 'price-asc') return priceA - priceB;
      if (val === 'price-desc') return priceB - priceA;
      return 0;
    });

    cards.forEach(c => grid.appendChild(c));
  }
})();

// ─── NEWSLETTER FORM ─────────────────────────────────────────────
(function () {
  const forms = document.querySelectorAll('.newsletter-form');
  forms.forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = form.querySelector('.newsletter-input');
      const btn = form.querySelector('.newsletter-submit');
      if (!input || !btn) return;
      const originalText = btn.textContent;
      btn.textContent = 'Thank you!';
      btn.disabled = true;
      input.value = '';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 3000);
    });
  });
})();

// ─── SCROLL REVEAL ───────────────────────────────────────────────
(function () {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.scroll-reveal').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });
})();
